export const isIncludedInArray = (arr = [], element) => {
  if (!arr || arr.length === 0) return false;

  return arr.includes(element);
};
